import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import styled from '@emotion/styled';
import { Icon } from '~/components/atomic';
import { HelmetHead } from '~/components/common';
import { Header } from '~/components/common/Header';
import { useLeaveChatRoomMutation } from '~/features/chatRoom';
import { useModal } from '~/hooks';
import { LeaveChatRoomRequest } from '~/types';
import { ModalParams } from '~/types';
import { PAGE_ROUTE } from '~/constants/url';
import { breakpoint } from '~/styles/themes';
import { useUserStore } from '~/store';
import { RoundedButtonBox } from '../MissionGame';
import ConceptLayout from './ConceptLayout';

export const ChatLayoutHeader = ({
  setChatHistoryOpen,
}: {
  setChatHistoryOpen: () => void;
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const chatroomId = id || '';
  const { openModal } = useModal();

  const email = useUserStore((state) => state.email);

  const location = useLocation();
  const isMissionGamePage = location.pathname.includes('mission') || false;

  const { mutate: leaveChatRoomMutate, isPending: isChatPending } =
    useLeaveChatRoomMutation();

  const handleLeaveRoomClick = async () => {
    const requestData: LeaveChatRoomRequest = {
      chatroom_id: chatroomId,
    };

    leaveChatRoomMutate(requestData, {
      onSuccess: ({ status }) => {
        navigate(PAGE_ROUTE.CHAT_LIST);
      },
    });
  };

  const ModalRequest: ModalParams = {
    title: 'Leave page',
    content: 'Are you sure you want to leave this chat?',
    click: isMissionGamePage ? () => navigate(-1) : handleLeaveRoomClick,
    buttonName: 'Leave',
  };
  return (
    <Header.Root transparentBg style={{ padding: '0 12px 0 4px' }}>
      <Header.PrevButton />
      <Header.Section gap={8}>
        <Header.Dart transparentBg={false} />
        <RoundedButtonBox>
          <Button onClick={setChatHistoryOpen}>
            <Icon color='content_light_1' size={23} iconName={'History'} />
          </Button>
        </RoundedButtonBox>
        <RoundedButtonBox>
          <Button onClick={() => openModal(ModalRequest)}>
            <Icon color='content_light_1' size={22} iconName={'Exit'} />
          </Button>
        </RoundedButtonBox>
      </Header.Section>
    </Header.Root>
  );
};
export default function ChatConcept() {
  const [isChatHistoryOpen, setIsChatHistoryOpen] = useState(false);
  return (
    <>
      <HelmetHead title='Concept Chat' />
      <ChatLayoutHeader setChatHistoryOpen={() => setIsChatHistoryOpen(true)} />
      <Container>
        <ConceptLayout
          isChatHistoryOpen={isChatHistoryOpen}
          setIsChatHistoryOpen={setIsChatHistoryOpen}
        />
      </Container>
    </>
  );
}

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-width: ${breakpoint.mobile_large};
  height: 100%;
  margin: 0 auto;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
`;
